import { render, staticRenderFns } from "./SwitchRecorrido.vue?vue&type=template&id=4db52011&scoped=true&"
import script from "./SwitchRecorrido.vue?vue&type=script&lang=ts&"
export * from "./SwitchRecorrido.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchRecorrido.vue?vue&type=style&index=0&id=4db52011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db52011",
  null
  
)

export default component.exports